<template>
  <v-container class="pa-0">
    <v-row>
      <v-dialog
        :value="success"
        width="500"
      >
        <v-card class="pa-4">
          <v-card-title :class="$breakpoint.is.xs ? 'title' : 'headline font-weight-regular'">
            Uw bericht is verzonden!
          </v-card-title>

          <v-card-text class="body-1 font-weight-regular black--text">
            We nemen zo spoedig mogelijk contact met u op. Klik op onderstaande knop om terug te keren naar de homepage.
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              rounded
              large
              width="150"
              to="/"
              nuxt
            >
              Terug
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-col cols="12" sm="6" class="pb-0 px-0 pa-sm-3">
        <form v-if="!success" method="post" class="mb-3" @submit.prevent="submit">
          <div v-for="field in template.fields" :key="field.position" class="left">
            <v-text-field
              v-if="field.type === 'text'"
              :id="field.name + '_' + id"
              v-model="form[field.name]"
              :error-messages="errors[field.name]"
              :prefix="label(field)"
              :required="!!field.required"
              color="primary lighten-1"
              filled
            />
            <v-text-field
              v-if="field.type === 'email'"
              :id="field.name + '_' + id"
              v-model="form[field.name]"
              :error-messages="errors[field.name]"
              :prefix="label(field)"
              :required="!!field.required"
              color="primary lighten-1"
              type="email"
              filled
            />
            <v-text-field
              v-if="field.type === 'number'"
              :id="field.name + '_' + id"
              v-model="form[field.name]"
              :error-messages="errors[field.name]"
              :prefix="label(field)"
              :required="!!field.required"
              color="primary lighten-1"
              type="number"
              filled
            />
            <v-select
              v-if="field.type === 'select'"
              :id="field.name + '_' + id"
              :items="field.options"
              :error-messages="errors[field.name]"
              :prefix="label(field)"
              :required="!!field.required"
              filled
            />
          </div>
        </form>
      </v-col>
      <v-col cols="12" sm="6" class="pt-0 px-0 pa-sm-3 text-center text-sm-right">
        <form v-if="!success" method="post" class="mb-3" @submit.prevent="submit">
          <div v-for="field in template.fields" :key="field.position" class="right">
            <v-textarea
              v-if="field.type === 'textarea'"
              :id="field.name + '_' + id"
              v-model="form[field.name]"
              :error-messages="errors[field.name]"
              :prefix="label(field)"
              :required="!!field.required"
              filled
              no-resize
              height="314px"
              color="primary lighten-1"
            />
            <template v-if="field.type === 'checkbox'">
              <p>{{ field.label }}</p>
              <v-checkbox
                v-for="(option, index) in field.options"
                :key="index"
                v-model="form[field.name]"
                :label="option"
                :value="option"
                :hide-details="index < (field.options.length - 1)"
                :error="errors[field.name] && (errors[field.name].length > 0)"
                filled
              />
            </template>
          </div>
          <recaptcha
            @error="onError"
            @success="onSuccess"
            @expired="onExpired"
          />
          <v-btn
            v-if="template.fields"
            type="submit"
            rounded
            class="text-center text-sm-right mt-6 mt-sm-0"
          >
            Verzenden
          </v-btn>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import commonForm from '~/plugins/mixins/form';

export default {
  mixins: [commonForm],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    html: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      success: false,
      template: {},
      form: {},
    };
  },
  async mounted() {
    const fields = await this.$axios.get('/forms/' + this.id);

    this.template = fields.data.data;

    // Set defaults
    const that = this;
    this.template.fields.forEach((field) => {
      if (field.type === 'checkbox') {
        // Default must be array to work
        that.form[field.name] = [];
      }
    });

    await this.$recaptcha.init();
  },
  methods: {
    onError(error) {
      console.log('Error happened:', error);
      // todo: handling
    },
    onSuccess(token) {
      console.log('Succeeded:', token);
      // todo: handling
    },
    onExpired() {
      console.log('Expired');
      // todo: handling
    },
    async submit() {
      try {
        const token = await this.$recaptcha.getResponse()
        await this.$axios.post('/forms/' + this.id, {...this.form, 'g-recaptcha-response': token});
        await this.$recaptcha.reset()
        this.success = true;
      } catch (e) {
        this.focusFirstError(this);
        console.log('Login error:', e);
      }
    },
    label(field) {
      if (field.required) {
        return `${field.label}*`;
      }

      return field.label;
    },
  },
};
</script>
